export default "__VITE_ASSET__DlDnHjK9__"